module.exports = __webpack_public_path__ + "img/chr_ts_21_6.f2ee270e.png";